import * as React from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import cn from 'classnames';
import { BaseButton, IconButton } from '../../BaseComponents';
import { useTheme } from '../../theme';
import { PromoCodeFieldType, PromoCodeStatus } from '../types';
import { isExistI18nTranslate } from '../../utils';
import { useConfig } from '../../context';
import { CdnIcon } from '@shared/ui';
import FormField from './Field/Field';
import Input from '../../Input';
const PromoCodeForm = props => {
    var _a;
    const { t } = useTranslation('PromoCode');
    const { PromoCodeForm: theme } = useTheme('PromoCode');
    const { promoCodesWithAgreement = [] } = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.SearchForm;
    const title = isExistI18nTranslate('Title', { ns: 'PromoCode' }) ? t('Title') : props.title;
    const getPromoCodeAgreement = useCallback((promoCode) => {
        if (!promoCodesWithAgreement.length) {
            return undefined;
        }
        return promoCodesWithAgreement === null || promoCodesWithAgreement === void 0 ? void 0 : promoCodesWithAgreement.find(promo => promo.regex.test(promoCode));
    }, [promoCodesWithAgreement]);
    const validateRequired = useCallback((value) => {
        var _a;
        const isRequired = typeof value === 'boolean' ? !value : !value || !((_a = value.trim) === null || _a === void 0 ? void 0 : _a.call(value));
        return isRequired ? t('Required') : undefined;
    }, [t]);
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { className: theme.title }, title),
        React.createElement(Form, { onSubmit: props.onSubmit }, ({ handleSubmit, values }) => {
            const promoCodeAgreement = getPromoCodeAgreement(values.promoCode);
            return (React.createElement("form", { onSubmit: handleSubmit, className: theme.form },
                React.createElement(Field, { name: "promoCode", validate: validateRequired }, ({ input, meta }) => (React.createElement(Input, { className: theme.codeInput, absoluteHintPosition: true, TextFieldProps: Object.assign(Object.assign({}, input), { label: t('Enter a promo code'), type: 'input', error: meta.touched && !meta.valid, helperText: meta.touched && !meta.valid ? meta.error : null }) }))),
                promoCodeAgreement && (React.createElement("div", { className: theme.form_additionalFields },
                    React.createElement(FormField, { name: "agreement", type: PromoCodeFieldType.Checkbox, label: t(`promoCheckboxLabel_${promoCodeAgreement.code}`), validate: validateRequired }))),
                React.createElement("div", { className: cn(theme.statusMessage, {
                        [theme.statusMessage_applied]: props.status === PromoCodeStatus.Applied,
                        [theme.statusMessage_notApplied]: props.status === PromoCodeStatus.NotApplied
                    }) },
                    props.submitButtonText && (React.createElement(BaseButton, { type: 'submit', className: cn(theme.button, {
                        // [theme.button_empty]: props.status === PromoCodeStatus.Empty,
                        // [theme.button_applied]: props.status === PromoCodeStatus.Applied
                        }), isLoading: props.isLoading, "data-promocode-submit-button": true }, (props.status === PromoCodeStatus.Empty ||
                        props.status === PromoCodeStatus.NotApplied) &&
                        props.submitButtonText)),
                    !props.submitButtonText && (React.createElement(IconButton, { type: 'submit', className: cn(theme.button, {
                            [theme.button_empty]: props.status === PromoCodeStatus.Empty,
                            [theme.button_applied]: props.status === PromoCodeStatus.Applied
                        }), isLoading: props.isLoading, isSuccess: props.status === PromoCodeStatus.Applied, "data-promocode-submit-button": true }, (props.status === PromoCodeStatus.Empty ||
                        props.status === PromoCodeStatus.NotApplied) && (React.createElement(CdnIcon, { icon: "Arrow/Forward" })))),
                    !props.isLoading && (React.createElement("span", { className: theme.statusText }, props.status === PromoCodeStatus.Applied && t('Promo code applied'))))));
        })));
};
export default PromoCodeForm;
